import { render } from "./BmListPage.vue?vue&type=template&id=f341a5ac&scoped=true"
import script from "./BmListPage.vue?vue&type=script&lang=js"
export * from "./BmListPage.vue?vue&type=script&lang=js"

import "./BmListPage.vue?vue&type=style&index=0&id=f341a5ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f341a5ac"]])

export default __exports__